import { getMoneyMask, toBrazilianDate } from '../../../../../../helpers';

class LancamentosFactory {
  makeConteudoTabela(lancamentos) {
    if (!lancamentos || lancamentos.length === 0) {
      return [];
    }

    return lancamentos.map(lancamento => ({
      data: toBrazilianDate(lancamento.data),
      descricaoLancamento: lancamento.descricaoLancamento,
      historico: lancamento.historico,
      idProcesso: lancamento.idProcesso ? Number(String(lancamento.idProcesso)).toLocaleString('pt-BR', { minimumFractionDigits: 0 }) : null,
      valorCredito: getMoneyMask(lancamento.valorCredito),
      valorDebito: getMoneyMask(lancamento.valorDebito),
    }));
  }
}

export const lancamentosFactory = new LancamentosFactory();
